import { gql } from '@apollo/client'

import { LEGACY_CONSTANT_ENTITY_FIELDS } from './constantEntities'

export const RX_SHIPMENT_FIELDS = gql`
  fragment RxShipmentFields on RxShipment {
    deliveredAt
    externalShipmentId
    shipmentCarrier
    shippedAt
    trackingId
  }
`

export const RX_ORDER_FIELDS = gql`
  ${RX_SHIPMENT_FIELDS}
  fragment RxOrderFields on RxOrder {
    externalOrderId
    placedAt
    promiseDeliveryDate
    rxShipments {
      ...RxShipmentFields
    }
  }
`

export const RX_USAGE_FIELDS = gql`
  ${LEGACY_CONSTANT_ENTITY_FIELDS}
  ${RX_ORDER_FIELDS}
  fragment RxUsageFields on RxUsage {
    externalRxUsageId
    dispensedAmount
    rxOrder {
      ...RxOrderFields
    }
    rxUsageState {
      ...LegacyConstantEntityFields
    }
  }
`

export const PRESCRIPTION_REFILL_FIELDS = gql`
  ${LEGACY_CONSTANT_ENTITY_FIELDS}
  fragment PrescriptionRefillFields on Prescription {
    id
    businessId
    name
    type
    createdAt
    updatedAt
    totalQuantity
    totalQuantityUnit {
      ...LegacyConstantEntityFields
    }
    drugExpirationDate
    refillExpirationDate
    state {
      ...LegacyConstantEntityFields
    }
    origin
    rxType
    deleted
    notes
    orderNumber
    partNumber
    globalVariationMapping {
      id
      chewyItems {
        count
        partNumber
      }
    }
  }
`

export const PRESCRIPTION_FIELDS = gql`
  ${LEGACY_CONSTANT_ENTITY_FIELDS}
  fragment PrescriptionFields on Prescription {
    id
    businessId
    name
    categoryId
    client {
      id
    }
    patient {
      id
    }
    doctorId
    rxNo
    type
    administrationQuantity
    administrationQuantityUnit {
      ...LegacyConstantEntityFields
    }
    administrationQuantityCustomUnit
    administrationFrequency {
      ...LegacyConstantEntityFields
    }
    administrationFrequencyNotes
    administrationCourseType
    administrationCourseLength
    administrationRoute {
      ...LegacyConstantEntityFields
    }
    drugExpirationDate
    prescribedDate
    globalInventoryId
    globalVariationId
    globalInventoryMapping {
      id
    }
    globalVariationMapping {
      id
      chewyItems {
        count
        partNumber
      }
    }
    globalFoodCatalogId
    globalFoodCatalogVariationId
    inventoryId
    numberRefills
    quantityPerRefill
    quantityPerRefillUnit {
      ...LegacyConstantEntityFields
    }
    quantityPerRefillCustomUnit
    refillExpirationDate
    totalQuantity
    totalQuantityUnit {
      ...LegacyConstantEntityFields
    }
    totalQuantityCustomUnit
    controlled
    deleted
    createdAt
    updatedAt
    rejectionReason
    state {
      ...LegacyConstantEntityFields
    }
    compoundingReasonState {
      ...LegacyConstantEntityFields
    }
    compoundingReason
    notes
    orderNumber
    partNumber
    drugInfo {
      customCompound
      customForm
      deliveryMethod {
        id
        name
      }
      description
      flavor
      form {
        ...LegacyConstantEntityFields
      }
      masterName
      strength
      strengthColor {
        ...LegacyConstantEntityFields
      }
      strengthUnits {
        ...LegacyConstantEntityFields
      }
      variationName
      perPackageAmount
      perPackageUnits {
        ...LegacyConstantEntityFields
      }
      packageType {
        ...LegacyConstantEntityFields
      }
      count
      compounded
    }
    mismatchWarning
    pdfUrl
    rxType
    origin
    signer {
      id
      firstName
      lastName
    }
    signatureUrl
    task {
      id
    }
    soapId
    invoice {
      id
    }
  }
`
